import React, {useEffect} from 'react'
import Encabezado from './Components/Encabezado'
import FooterResumen from './Components/ResumenFactura/FooterResumen'
import DocumentoTributario from './Components/ResumenFactura/DocumentoTributario'
import {useSelector} from 'react-redux'
import FooterFinalizacion from './Components/ResumenFactura/FooterFinalizacion'
import ModalsResumenControl from './Components/ResumenFactura/Modals/ModalsResumenControl'
import {State} from '../../reducers'
import {useHistory} from 'react-router'

const ResumenFactura = () => {
  const history = useHistory()
  const facturaEmitida = useSelector((state: State) => state.facturacion.facturaEmitda)
  const arrayP = useSelector((state: State) => state.facturacion.arrayProductos)
  

  useEffect(() => {
    if (arrayP.length === 0) history.push('/emitir-factura/formulario')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <ModalsResumenControl />
      <Encabezado url='/emitir-factura/formulario' />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout' >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell' style={{minHeight: '100vh'}} >
          <div className='card'>
            <DocumentoTributario />
          </div>
        </div>
        {!facturaEmitida ? <FooterResumen /> : <FooterFinalizacion />}
      </div>
    </>
  )
}

export default ResumenFactura
